import React from 'react'

interface DataRow {
  timestamp: string
  mV: string
  value: string
}

interface DataTableProps {
  title: string
  headers: string[]
  data: DataRow[]
  batteryVoltage?: string
  className?: string
  nested?: boolean
}

export const DataTable: React.FC<DataTableProps> = ({
  title,
  headers,
  data,
  batteryVoltage = '--',
  className = '',
  nested = false
}) => {
  const formatData = (rowData: DataRow) => [
    rowData.timestamp,
    rowData.mV,
    rowData.value
  ]

  const baseClasses = nested
    ? 'bg-white rounded-xl shadow-2xs overflow-hidden'
    : 'bg-white rounded-3xl shadow-sm overflow-hidden'

  return (
    <div className={`${baseClasses} ${className}`}>
      <div className="flex justify-between items-start p-4 border-b border-gray-200">
        <div className="text-base font-semibold text-gray-700 flex-1">
          {title}
        </div>
        <div className="text-center min-w-24">
          <div className="text-xs text-gray-500 mb-1">Battery voltage</div>
          <div className="text-lg font-semibold text-gray-700">
            {batteryVoltage}
          </div>
        </div>
      </div>

      <div className="w-full">
        {/* Header row */}
        <div className="flex bg-gray-50 border-b border-gray-100">
          {headers.map((header, index) => (
            <div
              key={index}
              className="flex-1 p-3 text-xs font-semibold text-gray-500 text-center"
            >
              {header}
            </div>
          ))}
        </div>

        {/* Data rows */}
        {data.length > 0
          ? data.map((rowData, rowIndex) => (
              <div
                key={rowIndex}
                className="flex border-b border-gray-100 last:border-b-0"
              >
                {formatData(rowData).map((cellData, cellIndex) => (
                  <div
                    key={cellIndex}
                    className="flex-1 p-3 text-xs text-gray-700 text-center"
                  >
                    {cellData}
                  </div>
                ))}
              </div>
            ))
          : // Empty rows when no data
            [...Array(3)].map((_, rowIndex) => (
              <div
                key={rowIndex}
                className="flex border-b border-gray-100 last:border-b-0"
              >
                {headers.map((_, cellIndex) => (
                  <div
                    key={cellIndex}
                    className="flex-1 p-3 text-xs text-gray-700 text-center"
                  >
                    --
                  </div>
                ))}
              </div>
            ))}
      </div>
    </div>
  )
}

export default DataTable
